import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { LibraryManagementFacadeService } from './service/library-management-facade.service';

@Injectable({ providedIn: 'root' })
export class SingleProductResolver implements Resolve<any> {
  libraryFacade = inject(LibraryManagementFacadeService);

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.paramMap.get('productId');
    return this.libraryFacade.fetchProductById(+id!);
  }
}
